import React from 'react';
import { Control } from 'react-hook-form';
import { FormInput } from '../components/shared/FormInput';
import { FormTextarea } from '../components/shared/FormTextarea';
import { TagInput } from '../components/shared/TagInput';
import { OnboardingData } from '../types';

interface Step1ProductFeaturesProps {
  control: Control<OnboardingData>;
}

const Step1ProductFeatures: React.FC<Step1ProductFeaturesProps> = ({ control }) => {
  return (
    <div className="space-y-6">
      {/* Question 0: Brand name */}
      <div>
        <FormInput
          name="step1_productFeatures.brandName"
          control={control}
          label="What is your brand name?"
          placeholder="Enter your brand name..."
          rules={{ required: 'Brand name is required' }}
        />
      </div>

      {/* Question 1: Top selling product/service */}
      <div>
        <FormTextarea
          name="step1_productFeatures.topSellingProduct"
          control={control}
          label="What is your top selling product/service?"
          placeholder="Enter your main product or service..."
          rows={2}
          rules={{ required: 'This field is required' }}
        />
      </div>

      {/* Question 2: What people like */}
      <div>
        <FormTextarea
          name="step1_productFeatures.whatPeopleLike"
          control={control}
          label="What people like about your product/service? What makes you different?"
          placeholder="Describe what customers love and what sets you apart..."
          rows={2}
          rules={{ required: 'This field is required' }}
        />
      </div>

      {/* Question 3: Upcoming dates */}
      <div>
        <FormTextarea
          name="step1_productFeatures.upcomingDates"
          control={control}
          label="Are there any upcoming dates we should be aware of?"
          placeholder="Product launches, events, campaigns..."
          rows={2}
          rules={{ required: 'This field is required' }}
        />
      </div>

      {/* Question 4: Features/benefits */}
      <div>
        <FormTextarea
          name="step1_productFeatures.features"
          control={control}
          label="What are the features/benefits of your product/service?"
          placeholder="List the key features and benefits you offer..."
          rows={2}
          rules={{ required: 'This field is required' }}
        />
      </div>

      {/* Question 5: Use cases */}
      <div>
        <label className="block text-sm text-text font-medium mb-3">Name 3–5 use cases.</label>
        <TagInput
          name="step1_productFeatures.useCases"
          control={control}
          placeholder="Add use case... (press Enter or comma)"
          rules={{
            validate: (value: string[]) => {
              if (!value || value.length < 3) {
                return 'Please add at least 3 use cases';
              }
              if (value.length > 5) {
                return 'Please add no more than 5 use cases';
              }
              return true;
            },
          }}
        />
      </div>

      {/* Question 6: Target industries */}
      <div>
        <FormInput
          name="step1_productFeatures.targetIndustries"
          control={control}
          label="What industries are you targeting?"
          placeholder="e.g., Technology, Healthcare, Education..."
          rules={{ required: 'This field is required' }}
        />
      </div>
    </div>
  );
};

export { Step1ProductFeatures };
